// ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop({ children }) {
	const { pathname } = useLocation();

	// Función para hacer scroll al top
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "instant",
		});
		// También para compatibilidad con navegadores antiguos
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	};

	// Scroll al top cuando cambia la ruta
	useEffect(() => {
		scrollToTop();
	}, [pathname]);

	// Scroll al top cuando se carga/recarga la página
	useEffect(() => {
		// Prevenir la restauración automática del scroll del navegador
		if ("scrollRestoration" in window.history) {
			window.history.scrollRestoration = "manual";
		}

		// Hacer scroll al top después de que todo esté cargado
		const handleLoad = () => {
			scrollToTop();
		};

		// Si la página ya está cargada, hacer scroll inmediatamente
		if (document.readyState === "complete") {
			// Pequeño delay para asegurar que el DOM esté completamente renderizado
			setTimeout(scrollToTop, 0);
		} else {
			// Si aún se está cargando, esperar al evento load
			window.addEventListener("load", handleLoad);
		}

		// También hacer scroll después de un pequeño delay adicional
		// para manejar casos donde el contenido se carga dinámicamente
		const timer = setTimeout(() => {
			scrollToTop();
		}, 100);

		return () => {
			window.removeEventListener("load", handleLoad);
			clearTimeout(timer);
		};
	}, []); // Solo se ejecuta una vez al montar

	return children || null;
}

export default ScrollToTop;
